import {Component, Input} from '@angular/core';
import { CommonModule } from '@angular/common';

@Component({
  selector: 'badge',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './badge.component.html',
  styleUrls: ['./badge.component.scss']
})
export class BadgeComponent {
  @Input() accent: string;
  @Input() color: string;
  constructor() {
    this.accent ??= '#262626';
    this.color ??= '#e5e5e5';
  }
}
